import styled from 'styled-components';

export const Stack = styled.div`
  position: relative;
  display: grid;
  width: 100%;
  gap: ${({ gap }) => gap};
  padding: ${({ padding }) => padding};
`;
